<template>
  <div no-body class="lku-brand">
    <b-row>
      <b-col lg="10">
        <b-input-group>
          <b-input-group-prepend><span class="pt-2 mr-3">Filter</span></b-input-group-prepend>
          <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
          <b-form-checkbox-group v-model="filterOn" class="ml-1 mt-1 mr-1">
            <b-form-checkbox value="mediumName">Medium</b-form-checkbox>
            <b-form-checkbox value="compcode">AMG Unit</b-form-checkbox>
            <b-form-checkbox value="produk">Item Name</b-form-checkbox>
          </b-form-checkbox-group>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="clearFilter()">Clear</b-button>
          </b-input-group-append>

          <!-- <b-input-group-append><span class="p-2">Active</span></b-input-group-append>
              <b-form-select v-model="tblData.isactive" :plain="true" :options="activeStatus" size="sm" @change="data()"></b-form-select> -->
        </b-input-group>
      </b-col>
    </b-row>
    <b-table class="mb-0" ref="tblCoa" style="font-size:smaller;" responsive striped hover :items="items"
      :fields="fields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc" :key="tblData.page" :filter="filter" :filterIncludedFields="filterOn"
      @filtered="onFiltered" @row-clicked="selectItem" :busy="isBusy">
      <!-- <template v-slot:cell(nomor)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
        </template> -->
      <template v-slot:cell(ratePrice)="data">{{ (data.item.ratePrice) | numFormat }}</template>
      <template v-slot:cell(otherInfo)="data">
        {{ data.item.otherInfo.replaceAll(/\n/g, ' | ') }}
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

    </b-table>
    <b-row>
      <b-col cols="4">
        <div class="pt-2">
          Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
          to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span v-else>{{
            tblData.page * tblData.limit }}</span>
          of {{ tblData.total }} entries
        </div>
      </b-col>
      <b-col cols="3">
        <b-row class="ml-2 mt-2">
          <span class="pt-1 pr-2">Limit per page</span>
          <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit" size="sm"
            style="width:80px !important;" />
        </b-row>
      </b-col>
      <b-col cols="5">
        <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
          v-model="tblData.page"></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
.lku-brand {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import crud from "../../apis/crud";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      isBusy: false,
      fields: [
        {
          key: "mediumName",
          label: "Medium",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "produk",
          label: "Item Name",
          sortable: true
        },
        {
          key: "otherInfo",
          label: "Other Info",
          sortable: true
        },
        {
          key: "compcode",
          thStyle: "width:50px",
          label: "AMG Unit",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "ratePrice",
          label: "Rate Price (IDR)",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "rateUnit",
          label: "Rate Unit",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
      ],
      items: [],
      tblData: {
        tablename: 'amg-rate-card',
        isactive: '',
        page: 1,
        limit: 10000,
        total: 0,
        sortBy: 'produk',
        sortDesc: false
      },
      activeStatus: [{ value: '', text: '-- ALL --' }, , { value: '0', text: 'Non Active' }, { value: '1', text: 'Active' }],
      updatetable: false,
      filter: null, filterOn: ['mediumName', 'produk']
    };
  },
  props: ["isactive"],
  created: async function () {
    this.data();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    clearFilter() {
      this.filter = '';
      this.filterOn = [];

    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    data: async function (ctx) {
      try {
        this.isBusy = true;
        this.tblData.customQuery = '';
        if (this.tblData.isactive) {
          this.tblData.customQuery = 'isactive=' + encodeURIComponent(this.tblData.isactive);
        }

        this.tblData.limit = 10000;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        this.lkuLoading = true;
        const list = await crud.list(this.tblData);
        this.lkuLoading = false;
        this.items = list;
        this.tblData.limit = 20;
        this.updatetable = !this.updatetable;

        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
      }

    },
    selectItem(item, index) {
      this.$emit("click", item);
    },
    refresh() {
      this.$refs.tblCoa.refresh();
    }
  }
};
</script>
